'use es6';

import { List } from 'immutable';
import getSourcesPropertyGroups from '../partial/analytics-partial-sources';
import createPropertiesGetterFromGroups from '../createPropertiesGetterFromGroups';
import { createUnifiedProperties } from './unified';
export const getPropertyGroups = () => {
  return createUnifiedProperties('ANALYTICS_SOURCES').getPropertyGroups().then(unifiedGroups => List([...unifiedGroups, ...getSourcesPropertyGroups()]));
};
export const getProperties = createPropertiesGetterFromGroups(getPropertyGroups);